var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{staticClass:"logo",attrs:{"src":"/logo.png","alt":"logo"}}),_c('div',{staticClass:"brand-name"},[_vm._v("Zbeacon")])])
}
var staticRenderFns = []

export { render, staticRenderFns }